/* global SideDrawer */

if (!customElements.get('facet-filters')) {

  class FacetFilters extends SideDrawer {

    constructor() {
      super();

      this.filteringEnabled = this.dataset.filtering === 'true';
      this.sortingEnabled = this.dataset.sorting === 'true';
      this.results = document.getElementById('filter-results');

      if (!this.results) return;

      window.initLazyScript(this, this.init.bind(this));
    }

    init() {

      this.resultsCountEl = document.getElementById('results-count');

      this.form = this.querySelector('form');

      if (this.filteringEnabled) {

        this.showFiltersBtn = document.querySelector('.js-show-filters');

        this.filters = this.querySelector('.facets__filters');

        this.activeFilters = document.querySelector('.active-filters');

        this.footer = this.querySelector('.facets__footer');

        this.filtersOpen = this.dataset.filtersOpen;

        if (this.showFiltersBtn) {
          this.showFiltersBtn.addEventListener(
            'click',
            this.showFilters.bind(this)
          );
        }

        /* SIMPLE FULL PAGE RELOAD FILTERING */
        this.filters.addEventListener('input', () => {

          const formData = new FormData(this.form);

          const searchParams = new URLSearchParams(formData);

          if (this.sortingEnabled && this.desktopSortBy) {
            searchParams.set('sort_by', this.desktopSortBy.value);
          }

          window.location.href =
            `${window.location.pathname}?${searchParams.toString()}`;
        });

        if (this.activeFilters) {
          this.activeFilters.addEventListener(
            'click',
            this.handleActiveFiltersClick.bind(this)
          );
        }
      }

      if (this.sortingEnabled) {

        this.desktopSortBy = document.getElementById('sort-by');

        if (this.desktopSortBy) {

          this.desktopSortBy.addEventListener('change', () => {

            const url = new URL(window.location.href);

            url.searchParams.set('sort_by', this.desktopSortBy.value);

            window.location.href = url.toString();

          });

        }

      }

      window.addEventListener(
        'on:debounced-resize',
        this.handleWindowResize.bind(this)
      );

      this.handleWindowResize();

    }

    /**
     * Opens filters drawer
     */
    showFilters() {
      this.open(this.showFiltersBtn);
    }

    /**
     * Active filters
     */
    handleActiveFiltersClick(evt) {

      if (evt.target.tagName !== 'A') return;

      evt.preventDefault();

      window.location.href = evt.target.href;

    }

    /**
     * Resize handling
     */
    handleWindowResize() {

      if (!theme.mediaMatches.md) {

        this.querySelectorAll('.filter').forEach((el) => {

          el.open = false;

          el.classList.remove('is-open');

        });

      } else {

        this.querySelectorAll('.filter').forEach((el, index) => {

          if (
            this.filtersOpen === 'all' ||
            (this.filtersOpen === 'some' && index < 5)
          ) {

            el.open = true;

            el.classList.add('is-open');

          }

        });

      }

    }

  }

  customElements.define('facet-filters', FacetFilters);

}